import { render } from "./ModalAjouterAuteur.vue?vue&type=template&id=f49c8598&scoped=true"
import script from "./ModalAjouterAuteur.vue?vue&type=script&lang=js"
export * from "./ModalAjouterAuteur.vue?vue&type=script&lang=js"

import "./ModalAjouterAuteur.vue?vue&type=style&index=0&id=f49c8598&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f49c8598"]])

export default __exports__